App.factory('ReminderResponse', ['restmod', restmod => {
    return restmod.model('/reminder_responses')
}])
